import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaCheck, FaArrowLeft } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Navbar from '../components/Navbar';
import './ServicePage.css';

const FullStackWebApp = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: 'ease-in-out',
      once: true,
      offset: 100
    });
    window.scrollTo(0, 0);
  }, []);

  const features = [
    'Custom UI/UX design',
    'Backend architecture & APIs',
    'Authentication & user roles',
    'Admin dashboards',
    'Payment integration',
    'Database design & optimization',
    'Deployment on cloud',
    'Scalability-ready structure'
  ];

  const processSteps = [
    'Requirement analysis',
    'Architecture design',
    'UI/UX mockups',
    'Development (frontend + backend)',
    'Testing',
    'Deployment',
    'Support & maintenance'
  ];

  return (
    <div className="service-page">
      <Navbar />
      <div className="service-hero">
        <Link to="/" className="back-button" data-aos="fade-right">
          <FaArrowLeft /> Back to Home
        </Link>
        <div className="service-hero-content" data-aos="fade-up">
          <h1 className="service-page-title">Full-Stack Web App Development</h1>
          <p className="service-hero-tagline">Build powerful, scalable and high-performance web applications.</p>
        </div>
      </div>

      <div className="service-content">
        <div className="service-section" data-aos="fade-up">
          <h2 className="section-heading">Overview</h2>
          <p className="section-text">
            We develop complete full-stack web applications tailored to your business needs. From backend APIs to clean front-end UI, 
            we deliver fast, secure, and scalable applications built on modern technology.
          </p>
        </div>

        <div className="service-section" data-aos="fade-up">
          <h2 className="section-heading">What You Get</h2>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-item" data-aos="fade-up" data-aos-delay={index * 50}>
                <FaCheck className="check-icon" />
                <span>{feature}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="service-section" data-aos="fade-up">
          <h2 className="section-heading">Who It's For</h2>
          <p className="section-text">
            Startups, SaaS products, enterprise systems, dashboards, booking apps, management tools, and more.
          </p>
        </div>

        <div className="service-section" data-aos="fade-up">
          <h2 className="section-heading">Our Process</h2>
          <div className="process-list">
            {processSteps.map((step, index) => (
              <div key={index} className="process-step" data-aos="fade-up" data-aos-delay={index * 100}>
                <div className="step-number">{index + 1}</div>
                <div className="step-content">{step}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="service-cta" data-aos="fade-up">
          <Link to="/contact" className="cta-button-primary">
            Start Building Your Web App →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FullStackWebApp;

